import React from "react";

import TimeslotRuleAdbreak from "./TimeslotRuleAdbreak";
import TimeslotRuleRandom from "./TimeslotRuleRandom";
import TimeslotRuleSequential from "./TimeslotRuleSequential";
import TimeslotRuleSpecific from "./TimeslotRuleSpecific";
import { TimeslotRuleMode } from "../../../api/FastAPI.types";

import type { JSX } from "react";

import type { TimeslotRule } from "../../../api/FastAPI.types";
import type { DropzoneRenderItemProps } from "../../dropzoneList/DropzoneListContainer";

type TimeslotRuleItemRendererProps = DropzoneRenderItemProps<TimeslotRule>;

function TimeslotRuleItemRenderer({
  item,
  isDragging,
  isDragDisabled,
  dragRef,
  onDeleteClick,
}: TimeslotRuleItemRendererProps): JSX.Element | null {
  switch (item.mode) {
    case TimeslotRuleMode.Specific:
      return (
        <TimeslotRuleSpecific
          dragRef={dragRef}
          isDragDisabled={isDragDisabled}
          isDragging={isDragging}
          onClickDelete={onDeleteClick}
          rule={item}
        />
      );
    case TimeslotRuleMode.Random:
      return (
        <TimeslotRuleRandom
          dragRef={dragRef}
          isDragDisabled={isDragDisabled}
          isDragging={isDragging}
          onClickDelete={onDeleteClick}
          rule={item}
        />
      );
    case TimeslotRuleMode.Sequential:
      return (
        <TimeslotRuleSequential
          dragRef={dragRef}
          isDragDisabled={isDragDisabled}
          isDragging={isDragging}
          onClickDelete={onDeleteClick}
          rule={item}
        />
      );
    case TimeslotRuleMode.Adbreak:
      return (
        <TimeslotRuleAdbreak
          dragRef={dragRef}
          isDragDisabled={isDragDisabled}
          isDragging={isDragging}
          onClickDelete={onDeleteClick}
          rule={item}
        />
      );
    default:
      return null;
  }
}

export default TimeslotRuleItemRenderer;
